<template>
  <div class="time-picker-container" :style="style()" @keydown.esc="escape" @keydown.enter="escape" @blur="escape">
    <div class="time-picker ms-dropdown flex-row">
      <div class="ms-input time-picker-item">
        <ms-button
          type="primary-outline"
          left-icon="up-arrow-thin"
          title="setting"
          class="m-auto"
          @click="hourChange(1)"
        />
        <div class="flex-row relative border">
          <input
            ref="hourInput"
            v-model="hour"
            :decimal-places="0"
            :max="23"
            :min="0"
            class="ms-input-item w-100 text-center"
            @focus="this.$refs.hourInput.select()"
            @keydown.tab.stop.prevent="onTab('hour')"
            @keydown.up.stop.prevent="hourChange(1)"
            @keydown.down.stop.prevent="hourChange(-1)"
            @input="onInputHour"
            @blur="onBlurHour"
          />
        </div>
        <ms-button
          type="primary-outline"
          left-icon="down-arrow-thin"
          title="setting"
          class="m-auto"
          @click="hourChange(-1)"
        />
      </div>
      <div class="double-dot-delimiter">:</div>
      <div class="ms-input time-picker-item">
        <ms-button
          type="primary-outline"
          left-icon="up-arrow-thin"
          title="setting"
          class="m-auto"
          @click="minuteChange(step)"
        />
        <div class="flex-row relative border">
          <input
            ref="minuteInput"
            v-model="minute"
            :decimal-places="0"
            :max="59"
            :min="0"
            class="ms-input-item w-100 text-center"
            @blur="onBlurMinute"
            @input="onInputMinute"
            @focus="this.$refs.minuteInput.select()"
            @keydown.tab.stop.prevent="onTab('minute')"
            @keydown.up.stop.prevent="minuteChange(step)"
            @keydown.down.stop.prevent="minuteChange(-step)"
          />
        </div>
        <ms-button
          type="primary-outline"
          left-icon="down-arrow-thin"
          title="setting"
          class="m-auto"
          @click="minuteChange(-step)"
        />
      </div>
      <div v-if="showSecond" class="double-dot-delimiter">:</div>
      <div v-if="showSecond" class="ms-input time-picker-item">
        <ms-button
          type="primary-outline"
          left-icon="up-arrow-thin"
          title="setting"
          class="m-auto"
          @click="secondChange(step)"
        />
        <div class="flex-row relative border">
          <input
            ref="secondInput"
            v-model="second"
            :decimal-places="0"
            :max="59"
            :min="0"
            class="ms-input-item w-100 text-center"
            @blur="onBlurSecond"
            @input="onInputSecond"
            @focus="this.$refs.secondInput.select()"
            @keydown.tab.stop="escape"
            @keydown.up.stop.prevent="secondChange(step)"
            @keydown.down.stop.prevent="secondChange(-step)"
          />
        </div>
        <ms-button
          type="primary-outline"
          left-icon="down-arrow-thin"
          title="setting"
          class="m-auto"
          @click="secondChange(-step)"
        />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Hiển thị số thành string với lenght = 2
 */
const numberToStringWithFixedLength = num => {
  return num.toString().padStart(2, '0');
};
/* --------------------------------
 * Hàm tách mảng
 */
const slice = (array, start, end) => {
  let length = array == null ? 0 : array.length;

  if (!length) {
    return [];
  }

  start = start == null ? 0 : start;

  end = end === undefined ? length : end;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }

  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : (end - start) >>> 0;
  start >>>= 0;

  let index = -1;

  const result = new Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
};
/** -----------------------------
 * Hàm tách mảng thành nhiều mảng nhỏ có độ dài cho trước
 * @param {arrays, size}
 * -------------------------------
 */
const chunk = (array, size) => {
  size = Math.max(size, 0);

  const length = array == null ? 0 : array.length;

  if (!length || size < 1) {
    return [];
  }

  let index = 0;

  let resIndex = 0;

  const result = new Array(Math.ceil(length / size));

  while (index < length) {
    result[resIndex++] = slice(array, index, (index += size));
  }

  return result;
};

import IMask from 'imask';

export default {
  name: 'Timepicker',
  props: {
    modelValue: {
      required: false,
    },
    step: {
      type: Number,
      default: 1,
    },
    showSecond: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const dateNow = new Date();
    return {
      hour: '00',
      minute: '00',
      second: '00',
      nowHour: `${dateNow.getHours()}`,
      nowMinute: `${dateNow.getMinutes()}`,
      nowSecond: `${dateNow.getSeconds()}`,
      height: '',
      width: '',
      mask: {
        mask: '00',
      },
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        me.modelToValue();
      },
    },
  },
  methods: {
    onTab(ele) {
      switch (ele) {
        case 'minute':
          if (this.showSecond) {
            this.$refs.secondInput.focus();
          } else {
            this.escape();
          }
          break;
        case 'hour':
          this.$refs.minuteInput.focus();
          break;
        case 'second':
          this.escape();
          break;
        default:
          break;
      }
    },
    /**
     * Xử lý sự kiện bấm nút up - down thay đổi giờ
     */
    hourChange(stepValue) {
      const me = this;
      me.hour = me.increaseValue(me.hour, 24, stepValue);
      me.updateTime();
    },
    /**
     * Xử lý sự kiện bấm nút up - down thay đổi phút
     */
    minuteChange(stepValue) {
      const me = this;
      me.minute = me.increaseValue(me.minute, 60, Number(stepValue));
      me.updateTime();
    },
    /**
     * Xử lý sự kiện bấm nút up - down thay đổi giây
     */
    secondChange(stepValue) {
      const me = this;
      me.second = this.increaseValue(me.second, 60, Number(stepValue));
      me.updateTime();
    },
    increaseValue(val, maxValue, stepValue) {
      return numberToStringWithFixedLength((Number(val) + maxValue + stepValue) % maxValue);
    },
    /**
     * Xử lý sự kiện nhập vào ô input hour
     */
    onInputHour() {
      // hàm này kiểm tra focus sang input min
      const me = this;
      const hour = me.hour;

      if ((hour.toString().length === 1 && Number(hour) >= 2) || hour.toString().length === 2) {
        me.onInputHourComplete();
      }
    },
    /**
     * Xử lý sự kiện nhập vào ô input hour
     */
    onInputHourComplete() {
      const me = this;
      const hour = me.hour;
      me.updateTime();
      me.$refs.minuteInput.focus();
    },
    /**
     * Xử lý sự kiện nhập vào ô input min
     */
    onInputMinute() {
      const me = this;
      const min = me.minute;
      if ((min.toString().length === 1 && Number(min) >= 6) || min.toString().length === 2) {
        me.onInputMinuteComplete();
      }
    },
    /**
     * Xử lý sự kiện nhập vào ô input min
     */
    onInputMinuteComplete() {
      const me = this;
      const min = me.minute;

      me.updateTime();
      if (me.showSecond) {
        me.$refs.secondInput.focus();
      }
    },
    /**
     * Xử lý sự kiện nhập vào ô input second
     */
    onInputSecond() {
      const me = this;
      const second = me.second;
      if ((second.toString().length === 1 && Number(second) >= 6) || second.toString().length === 2) {
        me.onInputSecondComplete();
      }
    },
    /**
     * Xử lý sự kiện nhập vào ô input second
     */
    onInputSecondComplete() {
      const me = this;
      const second = me.second;
      me.updateTime();
    },
    /**
     * Thực hiện cập nhật Giờ/Phút/Giây
     */
    updateTime() {
      const me = this;
      this.$emit('update:modelValue', me.timeValue);
      this.$emit('input', me.timeValue);
    },
    style() {},
    /**
     * Sự kiện thoát khỏi picker
     */
    escape(event) {
      this.updateTime();
      const me = this;
      if (event) {
        event.preventDefault();
        event.cancel = true;
      }
      me.updateTime();
      me.onClose(event);
    },

    onBlur(e) {
      this.onHide(e);
    },
    onBlurHour() {
      const me = this;
      me.hour = me.hourView;
      me.updateTime();
    },
    onBlurMinute() {
      const me = this;
      me.minute = me.minuteView;
      me.updateTime();
    },
    onBlurSecond() {
      const me = this;
      me.minute = me.secondView;
      me.updateTime();
    },
    /**
     * Emit close event
     */
    onClose(e) {
      const me = this;
      this.$emit('close', e);
    },

    /**
     * Emit close event
     */
    onHide(e) {
      const me = this;
      this.$emit('hide', e);
    },

    /**
     *
     */
    closeOut(e) {
      const me = this;
      if (
        !e.target.closest('.calendar') &&
        (!e.target.closest('.ms-timepicker') || e.target.closest('.ms-timepicker') != me.$parent.$el)
      ) {
        me.onHide(e);
      }
    },
    setDefaultTime() {
      const me = this;
      me.hour = numberToStringWithFixedLength(me.nowHour);
      if (me.step === 1) {
        me.minute = numberToStringWithFixedLength(me.nowMinute);
        me.second = numberToStringWithFixedLength(me.nowSecond);
      } else {
        me.minute = numberToStringWithFixedLength(me.step * Math.floor(Number(me.nowMinute) / me.step));
        me.second = numberToStringWithFixedLength(me.step * Math.floor(Number(me.nowSecond) / me.step));
      }
      me.updateTime();
    },

    modelToValue() {
      const me = this;
      if (me.modelValue) {
        try {
          const timeParts = me.modelValue.split(':');
          const [hour, minute, second] = timeParts;
          me.hour = numberToStringWithFixedLength(Number(hour));
          me.minute = numberToStringWithFixedLength(Number(minute));
          me.second = numberToStringWithFixedLength(Number(second));
        } catch (e) {
          me.setDefaultTime();
        }
      } else {
        me.setDefaultTime();
      }
    },
    /**
     * Khởi tạo mask cho input hour
     */
    initHourMask() {
      const me = this;
      const ele = me.$refs.hourInput;
      const mask = IMask(ele, me.mask);
      mask.on('complete', me.onInputHourComplete);
      me.hourMask = mask;
    },
    /**
     * Khởi tạo mask cho input minutes
     */
    initMinuteMask() {
      const me = this;
      const ele = me.$refs.minuteInput;
      const mask = IMask(ele, me.mask);
      mask.on('complete', me.onInputMinuteComplete);
      me.minuteMask = mask;
    },
    /**
     * Khởi tạo mask cho input second
     */
    initSecondMask() {
      const me = this;
      const ele = me.$refs.secondInput;
      const mask = IMask(ele, me.mask);
      mask.on('complete', me.onInputSecondComplete);
      me.secondMask = mask;
    },
  },

  computed: {
    timeValue() {
      const me = this;
      return me.showSecond ? `${me.hourView}:${me.minuteView}:${me.secondView}` : `${me.hourView}:${me.minuteView}`;
    },
    hourView() {
      return numberToStringWithFixedLength(Number(this.hour));
    },
    minuteView() {
      return numberToStringWithFixedLength(Number(this.minute));
    },
    secondView() {
      return numberToStringWithFixedLength(Number(this.second));
    },
  },
  created() {
    const me = this;
    document.addEventListener('click', me.closeOut);
    me.modelToValue();
  },
  beforeUnmount() {
    const me = this;
    document.removeEventListener('click', me.closeOut);
  },
  mounted() {
    const me = this;
    me.height = me.$el.offsetHeight;
    me.width = me.$el.offsetWidth;

    me.$refs.hourInput.focus();
    me.$emit('msMounted');
    me.initHourMask();
    me.initMinuteMask();
    if (me.showSecond) {
      me.initSecondMask();
    }
  },
  updated() {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsInput.scss';
@import '@/assets/scss/components/TimePicker.scss';

.time-picker-container {
  border-radius: 2px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);
  padding: 6px 26px;

  input {
    font-size: 18px;
    font-weight: 600;
    height: 26px;
    width: 46px;
  }

  .border {
    border-color: black;
  }
}
.time-picker-item {
  width: 48px;
}
.double-dot-delimiter {
  margin: auto 9px;
}
</style>
